import { HolisticFunctions } from '@/server';
import { InviteService } from '../admin/InviteService';

export class FirebaseInviteService implements InviteService {
  constructor(
    private readonly holisticFunctions: HolisticFunctions,
    private readonly auth: firebase.auth.Auth,
  ) {}

  public async inviteAdmin(email: string): Promise<void> {
    await this.holisticFunctions.createAdmin({ email });
    await this.auth.sendPasswordResetEmail(email);
  }

  public async inviteClientAdmin(
    clientId: string,
    email: string,
  ): Promise<void> {
    await this.holisticFunctions.createClientAdmin({ clientId, email });
    await this.auth.sendPasswordResetEmail(email);
  }
}
